import { Box } from '@mui/material';
import formatDecimal from 'src/compass/shared/util/formatDecimal';
import { ICasMRTCellProps } from './ICasMRTCellProps';

export function CasMRTCellRenderDecimal({ cell }: ICasMRTCellProps) {
  const value = cell.getValue();
  return value != null && <Box textAlign="center">{formatDecimal(value)}</Box>;
}
